var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{},[_c('div',{staticClass:"flex items-center gap-x-3"},[_c('ui-button',{staticClass:"py-2 mt-1",attrs:{"disabled":_vm.disabled || _vm.form.processing,"label":!_vm.subscription.invoice_sent_at ? 'Rechnung wurde versendet' : 'Rechungsversand zurücknehmen'},on:{"click":function($event){return _vm.submitForm()}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }